import { FC, useEffect, useState } from 'react';
import { PageProps } from 'gatsby';
import classNames from 'classnames';
import { DefaultLayout, OrderHistoryList } from '../../../components';

const AccountOrderHistoryPage: FC<PageProps<object, object, unknown, { orderDisplayId: string }>> = pageData => {
  const { orderDisplayId } = pageData.params;

  const [displayedOrderId, setDisplayedOrderId] = useState(
    !isNaN(parseInt(orderDisplayId)) ? parseInt(orderDisplayId) : undefined
  );

  useEffect(() => {
    if (displayedOrderId) window.history.pushState('', '', `/account/order-history/${displayedOrderId}`);
  }, [displayedOrderId]);

  return (
    <DefaultLayout title="Order History" className={classNames('account-order-history')}>
      <OrderHistoryList orderDisplayId={displayedOrderId} setDisplayedOrderId={setDisplayedOrderId} />
    </DefaultLayout>
  );
};

export default AccountOrderHistoryPage;
